export type OfferLabelIconType =
  | 'pre-approved'
  | 'filter'
  | 'secured-loan'
  | 'collateral-required'
  | 'personal-loan'
  | 'unsecured'
  | 'heloc'
  | 'line-of-credit'
  | 'consolidation';

type OfferProductSubType =
  | 'cash_advance'
  | 'education_offers'
  | 'debt_relief'
  | 'credit_builder'
  | 'overdraft_protection'
  | 'financial_wellness'
  | 'credit_repair'
  | 'employment_opportunity'
  | 'revenue_based_financing'
  | 'installment_loans'
  | 'cash_advance_moneylion';

export enum RepopulationSubTypes {
  cash_advance = 'Cash Advance',
  education_offers = 'Education Offers',
  debt_relief = 'Debt relief',
  credit_builder = 'Credit builder',
  overdraft_protection = 'Overdraft protection',
  financial_wellness = 'Financial wellness',
  credit_repair = 'Credit repair',
  employment_opportunity = 'Employment opportunity',
  revenue_based_financing = 'Revenue based financing',
  installment_loans = 'Installment loans',
  cash_advance_moneylion = 'Cash advance moneylion',
}

export interface RepopulationOffer {
  uuid: string;
  name: string;
  desc: string;
  url: string;
  partnerName: string;
  partnerImageUrl: string;
  recommendationScore: number;
  payout: number;
  productSubType: OfferProductSubType;
  disclaimer?: string;
  financialInstitutionUuid: string;
}

type SubmissionOfferSubType =
  | 'personal_loan'
  | 'line_of_credit'
  | 'secured_loan'
  | 'home_equity_line_of_credit';

export enum SubmissionSubTypes {
  personal_loan = 'Personal loan',
  line_of_credit = 'HELOC',
  secured_loan = 'Secured loan',
}

export interface SubmissionOffer {
  uuid: string;
  originator: {
    key: string;
    name: string;
    description: string;
    images: [
      {
        sizeKey: string;
        url: string;
      },
    ];
    disclaimer: string;
    companyUuid: string;
    financialInstitutionUuid: string;
  };
  originatorId: null | string;
  termLength: null | number;
  termUnit: string;
  maxAmount: null | number;
  minAmount: null | number;
  maxApr: null | number;
  minApr: null | number;
  meanApr: null | number;
  feeRate: null | number;
  maxFeeRate: null | number;
  minFeeRate: null | number;
  feeFixed: null | number;
  maxFeeFixed: null | number;
  minFeeFixed: null | number;
  allowPrepayment: boolean;
  prepaymentFee: null | number;
  monthlyPayment: null | number;
  maxMonthlyPayment: null | number;
  minMonthlyPayment: null | number;
  meanMonthlyPayment: null | number;
  maxTotalPayment: null | number;
  minTotalPayment: null | number;
  meanTotalPayment: null | number;
  terms: string;
  url: string;
  preQualified: boolean;
  preApproved: boolean;
  secured: boolean;
  sponsored: boolean;
  recommendationScore: null | number;
  productType: string;
  productSubType: SubmissionOfferSubType;
  payout: null | number;
  aprType: string;
  coApplicant: boolean;
  aprDescription: null | number | string;
  displayTermUnit: null | number | string;
  productSubTypeDisclaimer: null | number | string;
  monthlyPaymentDescription: null | number | string;
  termDescription: null | number | string;
  amountPrefix: null | number | string;
}

export interface OffersResponse {
  uuid: string;
  leadUuid: string;
  routingPartner?: 1 | 2;
  estimatedTotalDebt?: number;
  creditCardOffers: [];
  lifeInsuranceOffers: [];
  lineOfCreditOffers: [];
  loanOffers: Array<SubmissionOffer>;
  mortgageOffers: [];
  savingsOffers: [];
  specialOffers: Array<RepopulationOffer>;
  pendingOriginators: [];
  pendingResponses: [];
  unsecuredDebtVerified: boolean;
  XBC?: string;
  second_run_eligible?: boolean;
}

export interface FiltersData {
  sortBy: 'amount' | 'term' | 'rate' | null;
  amount: null | number;
  rate: null | number;
  lenders: string[] | null;
}
